import React, { useState } from "react";
import {
    Box,
    Text,
    Button,
    useToast,
    Image,
    InputGroup,
    InputLeftAddon,
    Input,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";

const PerksComponentMobile = ({ filmDetails }) => {

    const [bonus, setBonus] = useState(0);
    const navigate = useNavigate();

    const { id } = useParams();
    const toast = useToast();

    return (

        <>
            <Text
                mt={"10px"}
                ml={"10px"}
                display={{ base: "block", lg: "none" }}
                fontSize={"18px"}
                fontWeight={"600"}
                textAlign={"start"}
            >
                Choose your Perk
            </Text>


            <Box display={{ base: "block", lg: "none" }}>
                <Box
                    px={"10px"}
                    pt={"20px"}
                    pb={"50px"}
                    overflowY={"auto"}
                    maxH={"100vh"}
                    bg={""}
                    color={""}
                    className="perks-box"
                    display={"flex"}
                    overflowX={"auto"}
                    gap={"50px"}
                    pr={"50px"}
                    w={"100vw"}
                >

                    <Text
                        display={{ base: "none", lg: "block" }}
                        mt={"20px"}
                        textAlign={"start"}
                        fontSize={"25px"}
                    >
                        Support
                    </Text>

                    <Box
                        position={"relative"}
                        textAlign={"start"}
                        border={"1px solid gray"}
                        minW={"280px"}
                        h={"initial"}
                    >
                        <Image
                            h={"208px"}
                            w={"148px"}
                            objectFit={"cover"}
                            src="/images/movies/socialmediashoutout.png"
                            width={""}
                        />
                        <Box p={"10px"}>
                            <Text mt={""} textAlign={"start"} fontSize={"14px"}>
                                Make a pledge without a reward
                            </Text>
                            <Text mt={"10px"} textAlign={"start"} fontSize={"14px"}>
                                Pledge amount
                            </Text>
                            <InputGroup>
                                <InputLeftAddon>US$</InputLeftAddon>
                                <Input
                                    type="tel"
                                    placeholder="$"
                                    onChange={(e) => {
                                        setBonus(e.target.value);
                                    }}
                                />
                            </InputGroup>



                        </Box>
                        <Button
                            mt={"10px"}
                            borderRadius={"5px"}
                            colorScheme="orange"
                            width="100%"

                            sx={{
                                position: "absolute",
                                bottom: "10px",
                                width: "calc(100% - 20px)",
                                margin: "0 10px",
                            }}
                            disabled={bonus === 0}
                            onClick={() => {
                                if (bonus === 0) {
                                    toast({
                                        title: "Error",
                                        description:
                                            "Pledge amount should be greater than 0.",
                                        status: "error",
                                        duration: 3000,
                                        isClosable: true,
                                    });
                                    return;
                                } else {
                                    navigate(`/checkout/${id}?noReward=${bonus}`);
                                }
                            }}
                        >
                            PLEDGE NOW
                        </Button>
                    </Box>

                    <Text
                        display={{ base: "none", lg: "block" }}
                        mt={"20px"}
                        textAlign={"start"}
                        fontSize={"25px"}
                    >
                        Available Perks
                    </Text>

                    {filmDetails?.rewards?.reward_tiers.map((e, i) => {
                        return (
                            <>
                                <Box
                                    position={"relative"}
                                    textAlign={"start"}
                                    border={"1px solid gray"}
                                    minW={"280px"}
                                    h={"initial"}
                                >
                                    <Image
                                        h={"208px"}
                                        w={"100%"}
                                        objectFit={"cover"}
                                        src={
                                            process.env.REACT_APP_API_BASE_URL + e.image ||
                                            "/images/movies/socialmediashoutout.png"
                                        }
                                    />
                                    <Box p={"10px"}>
                                        <Box display={"flex"} justifyContent={"space-between"}>
                                            <Text fontWeight={"bold"}>{e?.title}</Text>
                                        </Box>
                                        <Text
                                                sx={{
                                                    textAlign: "center",
                                                    fontSize: "32px",
                                                    color: "#DD6B20",
                                                }}
                                            >${parseInt(e?.pricing).toLocaleString()}</Text>
                                        {/* <Text fontSize={"14px"}>{e?.description}</Text> */}
                                        <Box
                                            display={"flex"}
                                            alignItems={"center"}
                                            justifyContent={"space-between"}
                                            mt={"5px"}
                                        >
                                            {/* <Box>
              <Text fontSize={"12px"}>Backers</Text>
              <Text fontSize={"12px"}>0</Text>
            </Box> */}
                                            {e?.shipping?.shipping !== "no" && (
                                                <Box>
                                                    <Text fontSize={"14px"}>Ships to</Text>
                                                    <Text fontSize={"14px"}>
                                                        {e?.shipping?.destination}
                                                    </Text>
                                                </Box>
                                            )}
                                        </Box>
                                        <Text mt={"5px"} fontSize={"14px"}>
                                            Estimated delivery
                                        </Text>
                                        <Text fontSize={"12px"}>
                                            {" "}
                                            {e?.estimated_delivery_month +
                                                " " +
                                                e?.estimated_delivery_year}
                                        </Text>

                                        <Text mt={"5px"} fontSize={"14px"}>
                                            {e?.items.length} item included
                                        </Text>
                                        {/* <Text fontSize={"12px"}>
                        {e?.items?.map((e) => {
                          return <span>{e?.title}, </span>;
                        })}
                        </Text> */}
                                        <Box
                                            width={"100%"}
                                            mt={"25px"}
                                            display={"flex"}
                                            alignItems={"center"}
                                            justifyContent={"space-between"}
                                            gap={"10px"}
                                        >
                                            {/* <Button borderRadius={"5px"} width="100%">
            Details
          </Button> */}
                                            <Button
                                                borderRadius={"5px"}
                                                colorScheme="orange"
                                                width="100%"
                                                onClick={() =>
                                                    navigate(`/checkout/${id}?rewardId=${e?._id}`)
                                                }
                                            >
                                                {/* Pledge US${e?.pricing} */}
                                                GET THIS PERK
                                            </Button>
                                        </Box>
                                    </Box>
                                </Box>
                            </>
                        );
                    })}
                </Box>
            </Box>

        </>
    );
};

export default PerksComponentMobile;
